import React, {useEffect} from 'react';
import Title from '../miscellaneous/Title';
import {MAXTIME, useStyles} from "../miscellaneous/constants";
import {makeStyles} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SortedTable from "../miscellaneous/SortedTable";
import clsx from 'clsx';
import {isFiltered, numberWithSpaces} from "../miscellaneous/functions";

function createResults(selectedSolvers, data, benchmarks, filters) {
    let tmp = [];

    for (let i = 0; i < selectedSolvers.length; i++)
        if (data[selectedSolvers[i].id] === undefined)
            return []

    for (let i = 0; i < benchmarks.length; i++) {
        if (isFiltered(filters, benchmarks[i]) === false)
            continue;
        let sz = benchmarks[i].name.length;
        let n = sz > 30 ? benchmarks[i].name.substring(0, 10) + " ... " + benchmarks[i].name.substring(sz - 10, sz) : benchmarks[i].name
        let current = {
            name: benchmarks[i].name, nb_variables: benchmarks[i].nb_variables, nb_clauses: benchmarks[i].nb_clauses, result: benchmarks[i].status,
            info_domains: benchmarks[i].info_domains, info_constraints: benchmarks[i].info_constraints, useless_vars: benchmarks[i].useless_vars,
        };
        let bestValue = MAXTIME
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            if (0 && data[s.id][i].time === MAXTIME)
                current[s.name + " " + s.version] = null;
            else {
                let cf = (data[s.id][i].bug == 1) || ((benchmarks[i].status === "SAT" && data[s.id][i].status === "UNSAT") || (benchmarks[i].status === "UNSAT" && data[s.id][i].status === "SAT"))
                current[s.name + " " + s.version] = {
                    time: data[s.id][i].status === "UNSUPPORTED" ? "U" : (data[s.id][i].time <= filters.timeLimit ? data[s.id][i].time : "--"),
                    best: false,
                    classes: cf ? "conflict" : null
                }

                if (data[s.id][i].time < bestValue)
                    bestValue = data[s.id][i].time
            }
        }
        for (let j = 0; j < selectedSolvers.length; j++) {
            let s = selectedSolvers[j];
            if (current[s.name + " " + s.version].time === bestValue && selectedSolvers.length > 1 && current[s.name + " " + s.version].classes == null)
                current[s.name + " " + s.version].classes = 'best'
        }
        tmp.push(current);
    }
    return tmp;
}


const tableStyles = makeStyles({
    best: {
        color: " #6cd655"
    },
    conflict: {
        color: "red",
    },
    onright: {
        display: "flex",
        justifyContent: "space-between"
    },
    hd: {
        backgroundColor: "lightgrey",
        position: "sticky",
        top: "63px",
        zIndex: 10
    },

    over: {
        overflow: "initial"
    },
    table: {
        position: "relative"
    }

})

export default function Benchmarks(props) {
    const classes = tableStyles()
    const globalclasses = useStyles();
    if(props.filters.name == null)
        props.filters.name = ""

    if (props.selectedSolvers.length === 0) return null;

    let rows = createResults(props.selectedSolvers, props.results, props.benchmarks, props.filters)


    if (rows.length === 0) return null;


    let headCells = [
        {id: 'id', numeric: false, disablePadding: false, label: 'Instance'},
        {id: 'nb_variables', numeric: true, disablePadding: false, label: "V"},
        {id: 'nb_clauses', numeric: true, disablePadding: false, label: "C"},
        {id: 'result', numeric: false, disablePadding: false, label: "Status"}
    ]


    for(let r of rows) {
        r["nb_variables"] = numberWithSpaces(r["nb_variables"])
        r["nb_clauses"] = numberWithSpaces(r["nb_clauses"])
        for(let s of props.selectedSolvers)
            r[s.name + " " + s.version].time = numberWithSpaces(r[s.name+ " " + s.version].time)
    }

    props.selectedSolvers.forEach(s => headCells.push({
        id: s.name + " " + s.version,
        numeric: true,
        disablePadding: false,
        label: s.name + " " + s.version
    }))


    return (
        <Paper className={clsx(globalclasses.paper, classes.over)}>
            <Title>
                <div style={{color:'#408033'}}>Detailed results <small><small>(solving times in seconds per solver)</small></small></div>
            </Title>

            <SortedTable order='id' asc='desc' tooltip={props.competition.type === "csp"}
                         rows={rows.filter(item => props.filters.name.length < 3 || item.name.includes(props.filters.name))} headCells={headCells}
                         headerClasses={classes}/>
        </Paper>
    )

}